import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './QuantityCounter.scss';

const QuantityCounter = ({ value, onChange, disable }) => {
  return (
    <div className='quantity-counter'>
      {value === 0 && (
        <button type='button' className='counter-button add' onClick={() => onChange(1)} disabled={disable}>
          +
        </button>
      )}
      {value !== 0 && (
        <div className='counter-control'>
          <button type='button' className='counter-button minus' onClick={() => onChange(-1)}>
            -
          </button>
          <div className='counter-value'>{value}</div>
          <button type='button' className='counter-button plus' onClick={() => onChange(1)} disabled={disable}>
            +
          </button>
        </div>
      )}
    </div>
  );
};

QuantityCounter.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(QuantityCounter);
